import React from 'react';
import { getMessage } from 'util/locale';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { LabelWrapper } from '@tcc/crate';
import SeedProductSelectorRmDropdowns from 'edit/seed-product-selector/SeedProductSelectorRmDropdowns';
import SeedProductSelectorRmInputs from 'edit/seed-product-selector/SeedProductSelectorRmInputs';

const baseString = 'vra-seed-product-selector-rm';
const SeedProductSelectorRm = ({
  onChangeRm,
  rmValues,
  searchParams,
  useDropdowns,
  validationResult
}) => {
  const classString = classNames({
    [`${baseString}`]: true
  });

  return (
    <section className={classString}>
      <LabelWrapper label={getMessage('relative-maturity')} />
      {
        useDropdowns ? (
          <SeedProductSelectorRmDropdowns
            onChangeRm={onChangeRm}
            rmValues={rmValues}
            searchParams={searchParams}
            validationResult={validationResult}
          />
        ) : (
          <SeedProductSelectorRmInputs
            onChangeRm={onChangeRm}
            rmValues={rmValues}
            validationResult={validationResult}
          />
        )
      }
    </section>
  );
};
SeedProductSelectorRm.propTypes = {
  onChangeRm: PropTypes.func.isRequired,
  rmValues: PropTypes.array.isRequired,
  searchParams: PropTypes.object.isRequired,
  useDropdowns: PropTypes.bool.isRequired,
  validationResult: PropTypes.object // Can't have .isRequired because passing undefined is valid.
};
export default SeedProductSelectorRm;
